export const LANDING = '/';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const NEW_POSTER = '/posters/new';
export const POSTERS = '/posters';
export const EDIT_POSTER = '/posters/edit/:posterid';